import { useMutation } from '@apollo/client';
import type { InsertScimDomainMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertScimDomainDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useInsertScimDomainTRPC } from './useInsertScimDomainTRPC';

type InsertScimDomainInput = { domain: string };

export const useInsertScimDomain = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [insertScimDomainGraphQL, graphqlState] = useMutation(
    InsertScimDomainDocument,
    {
      update: (cache) => {
        evictField(cache, 'getScimConfig');
      },
    }
  );

  const trpcMutation = useInsertScimDomainTRPC();

  const insertScimDomain = async (
    variables: InsertScimDomainInput
  ): Promise<InsertScimDomainMutation> => {
    if (trpcEnabled) {
      return trpcMutation.insertScimDomain(variables);
    }

    const result = await insertScimDomainGraphQL({ variables });
    if (!result.data) {
      throw new Error('Failed to insert SCIM domain');
    }

    return result.data;
  };

  return {
    insertScimDomain,
    loading: trpcEnabled ? trpcMutation.loading : graphqlState.loading,
    error: trpcEnabled ? trpcMutation.error : graphqlState.error,
  };
};
